module.exports = __webpack_public_path__ + "static/media/cr.aa78b139.svg";